export default "__VITE_ASSET__CaDI74ND__"